<template>
    <div class="page-layout blank" style="overflow-y: auto;">
        <div class="pb-10" style="min-height:560px;">
            <div style="overflow-x: auto;overflow-y: hidden;">
                <div class="d-flex align-items-center mob-list-scroll">
                    <div class='slant-tabs' :class="{'activeTab':active_tab == 'overall','new-blue':active_tab == 'overall'}" @click="selectView('overall',true)">
                        <span v-if="$route.path == '/pm/ticketdetails'">
                            PM Tickets
                        </span>
                        <span v-else>Overall</span>
                        <span class="ticket_count" :class="{'count-ticket':active_tab == 'overall'}">{{total_tickets}}</span>
                    </div>
                    <div class='slant-tabs ml-2' :class="{'activeTab':active_tab == 'open','new-blue':active_tab == 'open'}" @click="selectView('open',true)">
                    <span>Opened</span>
                        <span class="ticket_count" :class="{'count-ticket':active_tab == 'open'}">{{open}}</span>
                    </div>
                    <div class='slant-tabs ml-2' :class="{'activeTab':active_tab == 'unassigned','new-blue':active_tab == 'unassigned'}" @click="selectView('unassigned',true)">
                    <span>Unassigned</span>
                        <span class="ticket_count" :class="{'count-ticket':active_tab == 'unassigned'}">{{unassigned}}</span>
                    </div>
                    <div class='slant-tabs ml-2' :class="{'activeTab':active_tab == 'inprogress','new-blue':active_tab == 'inprogress'}" @click="selectView('inprogress',true)">
                    <span>In Progress</span>
                        <span class="ticket_count" :class="{'count-ticket':active_tab == 'inprogress'}">{{inprogress}}</span>
                    </div>
                    <div class='slant-tabs ml-2' :class="{'activeTab':active_tab == 'fixed','new-blue':active_tab == 'fixed'}" @click="selectView('fixed',true)">
                        <span>Fixed</span>
                        <span class="ticket_count" :class="{'count-ticket':active_tab == 'fixed'}">{{fixed}}</span>
                    </div>
                    <div class='slant-tabs ml-2' :class="{'activeTab':active_tab == 'reopened','new-blue':active_tab == 'reopened'}" @click="selectView('reopened',true)">
                <span>Reopened</span>
                        <span class="ticket_count" :class="{'count-ticket':active_tab == 'reopened'}">{{reopened}}</span>
                    </div>
                    <div class='slant-tabs ml-2' :class="{'activeTab':active_tab == 'closed','new-blue':active_tab == 'closed'}" @click="selectView('closed',true)">
                    <span>Closed</span>
                        <span class="ticket_count" :class="{'count-ticket':active_tab == 'closed'}">{{closed}}</span>
                    </div>
                    <div class='slant-tabs ml-2' :class="{'activeTab':active_tab == 'review','new-blue':active_tab == 'review'}" @click="selectView('review',false)">
                    <span>Review</span>
                        <span class="ticket_count" :class="{'count-ticket':active_tab == 'review'}">{{ review }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event.js';
import ticket from '../mixins/ticket';
const Overall = () => import("../Tickets/Overall.vue");
const ReviewTickets = () => import("./ReviewTickets.vue")
const TicketDetails = () => import("../Tickets/TicketDetails.vue");
const Tab = () => import("./Tab.vue");

import dashboard from '../mixins/dashboard.js';
export default {
    mixins:[dashboard, ticket],
    components:{
            Overall,
            TicketDetails,
            Tab,
            ReviewTickets
     },
    data(){
        return{
            active_tab: 'overall',
            hideOverall:true,
            active_ticket:'Email',
            closed:0,
            fixed:0,
            open:0,
            inprogress:0,
            reopened:0,
            review: 0,
            total_tickets:0,
            unassigned:0,
            statusTab:[],
            ajax_call_in_progress:false,
            temp_dashb_filter: null,
            show_review_tickets: false,
        }
    },
    methods:{
        selectView(obj, is_tab_selected){
            this.active_tab = obj;
            switch(obj){
                case 'overall':
                    this.show_review_tickets = false
                    this.statusTab = [];
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'overall'} });
                    break;
                case 'open':
                    this.show_review_tickets = false
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'opened'} });
                    break;
                case 'inprogress':
                    this.show_review_tickets = false
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'inprogress'} });
                    break;
                case 'fixed':
                    this.show_review_tickets = false
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'fixed'} });
                    break;
                case 'closed':
                    this.show_review_tickets = false
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'closed'} });
                    break;
                case 'reopened':
                    this.show_review_tickets = false
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'reopened'} });
                    break;
                case 'unassigned':
                    this.show_review_tickets = false
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'unassigned'} });
                    break;
                case 'review':
                    this.statusTab = [];
                    // this.statusTab.push(obj);
                    this.show_review_tickets = true
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'review'} });
                    break;
            };
            this.getReviewTicketsCount()
            let status = {
                status_tab : this.statusTab,
                is_tab_selected : is_tab_selected
            }
            EventBus.$emit('updateTableView',status);
        },
        selectViewByFilter(obj, is_tab_selected, dashboard_filter){
            this.active_tab = obj;
            switch(obj){
                case 'overall':
                    this.statusTab = [];
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'overall'} });
                    break;
                case 'open':
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'opened'} });
                    break;
                case 'inprogress':
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'inprogress'} });
                    break;
                case 'fixed':
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'fixed'} });
                    break;
                case 'closed':
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'closed'} });
                    break;
                case 'reopened':
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'reopened'} });
                    break;
                case 'unassigned':
                    this.statusTab = [];
                    this.statusTab.push(obj);
                    this.$router.push({ path: "/ticketdetails", query: {view_ticket: 'unassigned'} });
                    break;
            };
            let status = {
                status_tab : this.statusTab,
                is_tab_selected : is_tab_selected,
                dashboard_filter: dashboard_filter
            }
            EventBus.$emit('updateTableView',status);
        },
        selectTickets(){
            this.hideOverall = false
        },
        selectViewDetail(ticket_obj){
            this.active_ticket = ticket_obj
        },
        showSelectedTicket(id){
            this.hideOverall = false
            this.$router.push({
                path: '/tickets/details/'+id
            })
        },
        async getTicketCountAPI(){
            let param = {
                is_maintenance: true
            }
            let res = await this.getTicketCount(String(this.$route.path).startsWith('/pm') ? param : {})
            this.closed = res.response.closed
            this.fixed = res.response.fixed
            this.open = res.response.open
            this.inprogress = res.response.inprogress
            this.reopened = res.response.reopened
            this.total_tickets = res.response.total_tickets
            this.unassigned = res.response.unassigned
        },
        showActiveView(){
            this.ajax_call_in_progress = true;
            if(this.temp_dashb_filter != null){
                switch(this.$route.query.view_ticket){
                    case 'overall':
                        this.selectViewByFilter('overall', true, this.temp_dashb_filter)
                        break;
                    case 'opened':
                        this.selectViewByFilter('open', true, this.temp_dashb_filter)
                        break;
                    case 'inprogress':
                        this.selectViewByFilter('inprogress', true, this.temp_dashb_filter)
                        break;
                    case 'fixed':
                        this.selectViewByFilter('fixed', true, this.temp_dashb_filter)
                        break;
                    case 'closed':
                        this.selectViewByFilter('closed', true, this.temp_dashb_filter)
                        break;
                    case 'reopened':
                        this.selectViewByFilter('reopened', true, this.temp_dashb_filter)
                        break;
                    case 'unassigned':
                        this.selectViewByFilter('unassigned', true, this.temp_dashb_filter)
                        break;
                    case 'assigned':
                        this.selectViewByFilter('overall', true, this.temp_dashb_filter)
                        break;
                    // case 'inprogress':
                    //     this.selectView('overall',true)
                    //     break;
                    case 'reject':
                        this.selectViewByFilter('overall',true, this.temp_dashb_filter)
                        break;
                    case 'schedule':
                        this.selectViewByFilter('overall', true, this.temp_dashb_filter)
                        break;
                };
            } else {
                switch(this.$route.query.view_ticket){
                    case 'overall':
                        this.selectView('overall', true)
                        break;
                    case 'opened':
                        this.selectView('open',true)
                        break;
                    case 'inprogress':
                        this.selectView('inprogress',true)
                        break;
                    case 'fixed':
                        this.selectView('fixed',true)
                        break;
                    case 'closed':
                        this.selectView('closed', true)
                        break;
                    case 'reopened':
                        this.selectView('reopened',true)
                        break;
                    case 'unassigned':
                        this.selectView('unassigned',true)
                        break;
                    case 'assigned':
                        this.selectView('overall',true)
                        break;
                    // case 'inprogress':
                    //     this.selectView('overall',true)
                    //     break;
                    case 'reject':
                        this.selectView('overall',true)
                        break;
                    case 'schedule':
                        this.selectView('overall',true)
                        break;
                    case 'review':
                        this.selectView('review',false)
                        break;
                };
            }
            this.ajax_call_in_progress = false;
        },
        async getReviewTicketsCount(){
            try{
                // this.ajax_loader = true
                let params = {
                    "limit": 10,
                    "skip": 0
                }
                let response = await this.ListTicketsToReview(params);
                this.review = response.response.total_no_of_tickets
                // this.ajax_loader = false
            } catch(err) {
                console.log(err)
            }
        }
    },
    mounted(){
        if(localStorage.getItem('storeDashboardFilter')){
            this.temp_dashb_filter = JSON.parse(localStorage.getItem('storeDashboardFilter'))
            localStorage.removeItem('storeDashboardFilter')
        }
        EventBus.$on('UpdateTab', () => {
            this.selectView('overall',false)
        })
        EventBus.$on('RecallStatusTabs', () => {
            this.getTicketCountAPI()
        })
        this.getTicketCountAPI()
        setTimeout(() => {
            this.showActiveView();
        }, 1000);
        EventBus.$on('updateActiveView',()=>{
            this.getTicketCountAPI()
        })
        this.getReviewTicketsCount()
    },
    // watch:{
    //     "$route.path": function (path) {
    //         console.log(path)
    //     }
    // },
    destroyed(){
        EventBus.$off('updateActiveView');
    }
}
</script>
<style scoped>
.ticket_count{
    background-color: #7b7f97;
    border-radius: 20px;
    font-size: 10px;
    font-weight: 600 !important;
    color: #ffffff;
    margin-left: 4px;
    padding: 0px 6px;
}
.count-ticket{
    background-color: #1b57ad;
    border-radius: 20px;
    font-size: 10px;
    font-weight: 600 !important;
    color: #ffffff;
    margin-left: 4px;
    padding: 0px 6px;
}
.ticket_tab{
    background-color: #005dae;
}
.activeColor{
    background-color: #005dae;
    color: #ffffff;
}
.email-buttons{
    display: none;
}
@media screen and (max-width: 991px){
    .mob-list-scroll{
        min-width: 991px;
    }
}
</style>